<!-- 企业级-业务领域-仓储业务-添加预约单 -->
<template>
  <div class="mainArea CAddBook">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <CBreadCrumb></CBreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">
        <!-- 搜索框 -->
        <div class="searchBox">
          <el-form :inline="true" :model="addForm" label-position="top">
            <el-form-item label="预约类型">
              <el-select v-model="addForm.type" placeholder="预约类型">
                <!-- <el-option label="预约入库" value="1"></el-option> -->
                <el-option label="预约出库" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="操作人">
              <el-select v-model="addForm.type" placeholder="请选择操作人" filterable>
                <el-option label="梁大大" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="手机号码">
              <el-input v-model="addForm.phone" placeholder="请输入手机号码"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <!-- 添加预约信息 -->
        <div class="addButton">
          <el-button type="primary" @click="openDio('add')">添加产品</el-button>
        </div>

        <el-table v-loading="loading" :data="bookData" style="width: 100%">
          <el-table-column type="index" label="序号" width="80"></el-table-column>
          <el-table-column label="产品编号" prop="Id"></el-table-column>
          <el-table-column label="产品名称" prop="ProductName"></el-table-column>
          <el-table-column label="产品批号" prop="ProductNumber"></el-table-column>
          <el-table-column label="类别" prop="Type"></el-table-column>
          <el-table-column label="规格" prop="Spec"></el-table-column>
          <el-table-column label="供应商" prop="Supplier"></el-table-column>
          <el-table-column label="仓库" prop="WareName"></el-table-column>
          <el-table-column label="库位" prop="ReserName"></el-table-column>
          <el-table-column label="货架" prop="ShelvesName"></el-table-column>
          <el-table-column label="货位" prop="LocationName"></el-table-column>
          <el-table-column label="入库数">
            <template slot-scope="scope"></template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text">修改</el-button>
              <el-button type="text">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="paging" v-if="total>limits">
          <el-pagination
            @current-change="CurrentChange"
            :current-page.sync="curr"
            :page-size="limits"
            layout="prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
        <div class="btnDiv">
          <el-button size="medium" @click="backUp">取消</el-button>
          <el-button size="medium" type="primary">确定</el-button>
        </div>
      </div>

      <el-dialog :title="dioTitle" :visible.sync="bookDio" :width="dioWidth" class="configDio" center>
        <div class="contDio">
          <el-form ref="form" :inline="true" :model="dioform">
            <el-form-item label="">
              <div>产品编号</div>
              <el-input size="small" class="w235" v-model="dioform.Id" @change="ProductDetail" placeholder="输入关键词搜索或双击选择产品" @dblclick.native="openProductDio"></el-input>
            </el-form-item>
            <el-form-item label="">
              <div>产品名称</div>
              <el-input size="small" class="w235" v-model="dioform.productName" disabled></el-input>
            </el-form-item>
            <el-form-item label="">
              <div>产品批号</div>
              <el-input size="small" class="w235" v-model="dioform.productNumber" disabled></el-input>
            </el-form-item>
            <el-form-item label="">
              <div>规格</div>
              <el-input size="small" class="w235" v-model="dioform.spec" disabled></el-input>
            </el-form-item>
            <el-form-item label="">
              <div>供应商</div>
              <el-input size="small" class="w235" v-model="dioform.supplier" disabled></el-input>
            </el-form-item>
            <el-form-item label="">
              <div>库区</div>
              <el-cascader size="small" class="w235" @change="wareChange" placeholder="请选择货位信息" :options="dioform.wareList" :props="dioform.props" :show-all-levels="false" clearable></el-cascader>
            </el-form-item>
            <el-form-item label="">
              <div>RFID编码</div>
              <el-input size="small" class="w300" v-model="dioform.rfid" placeholder="请连接扫描设备或者手动逐个添加RFID"></el-input>
              <el-button size="small" type="primary" @click="addRfid()">添加</el-button>
            </el-form-item>
          </el-form>
          <el-table :data="dioform.RFIDlist" style="width: 100%" max-height="270px">
            <el-table-column type="index" label="序号" width="80"></el-table-column>
            <el-table-column label="产品名称" prop="ProductName"></el-table-column>
            <el-table-column label="RFID编号" prop="Rfid"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="delRfid(scope.$index)">[ - ]</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- <div class="paging" v-if="dioform.total>dioform.limits">
            <el-pagination
              @current-change="CurrDioChange"
              :current-page.sync="dioform.curr"
              :page-size="dioform.limits"
              layout="prev, pager, next, jumper"
              :total="dioform.total">
            </el-pagination>
          </div> -->
        </div>
        <span slot="footer">
          <el-button @click="bookDio = false">取消</el-button>
          <el-button type="primary">确定</el-button>
        </span>
      </el-dialog>

      <el-dialog title="选择产品" :visible.sync="productDio" width="600px" class="configDio">
        <div class="contDio">
          <div class="search">
            <el-input size="small" v-model="productform.name" placeholder="产品编号或产品名称" clearable class="w235" @keyup.enter.native="ProductList()"></el-input>
            <el-button size="small" type="primary" @click="ProductList()">搜索</el-button>
          </div>
          <el-table :data="productform.list" style="width:100%" @current-change="clickChange" max-height="400px">
            <el-table-column label="选择" width="55" fixed>
              <template slot-scope="scope">
                <el-radio v-model="productform.checkrow" :label="scope.row"></el-radio>
              </template>
            </el-table-column>
            <el-table-column label="产品编号" prop="Id"></el-table-column>
            <el-table-column label="产品名称" prop="ProductName"></el-table-column>
            <el-table-column label="产品批号" prop="ProductNumber"></el-table-column>
            <el-table-column label="类别" prop="Type"></el-table-column>
            <el-table-column label="规格" prop="Spec"></el-table-column>
            <el-table-column label="单位" prop="Unit"></el-table-column>
            <el-table-column label="重量" prop="Weight"></el-table-column>
            <el-table-column label="供应商" prop="Supplier"></el-table-column>
            <el-table-column label="生产日期" prop="Date"></el-table-column>
            <el-table-column label="有效期" prop="Validity"></el-table-column>
          </el-table>
        </div>
        <span slot="footer">
          <el-button type="primary" @click="submitProduct()">确定</el-button>
        </span>
      </el-dialog>
  </div>
</template>

<script>
  import CBreadCrumb from "../../Layout/CBreadCrumb.vue"
  import { showToast,updataBreadCrumb } from "../../../../../static/js/utility/utility.js"
  import { bussinessApi } from '../../../../../static/js/api';
  var vm
  export default {
    name: 'CAddBook',
    components: {
      CBreadCrumb,
    },
    data() {
      return {
        addForm:{
          type:'',//预约类型
          name:'',//操作人
          phone:'',//手机号
        },

        loading:false,
        bookData:[],//仓库数据

        //分页
        curr:1,
        limits:10,
        total:0,

        bookDio:false,//弹窗
        dioTitle:'',//弹窗标题
        dioWidth:'',//弹窗宽度
        dioType:'',//弹窗类型
        dioform:{
          Id:'',//产品id
          productName:'',//产品名称
          productNumber:'',//产品批号
          type:'',//类别
          spec:'',//规格
          supplier:'',//供应商
          location:'',//当前选中仓库空间ID
          rfid:'',//rfid
          RFIDlist:[],
          //分页
          // curr:1,
          // limits:10,
          // total:0,

          wareList:[{
            Id:'1',
            Name:'一级',
            Children:[{
              Id:'2',
              Name:'二级'
            },{
              Id:'3',
              Name:'二级二'
            }]
          },{
            Id:'11',
            Name:'十一级',
            Children:[{
              Id:'12',
              Name:'十二级'
            },{
              Id:'13',
              Name:'十二级二'
            }]
          }],
          props:{
            checkStrictly: true,
            label:'Name',
            value:'Id',
            children:'Children'
          },
        },

        productDio:false,
        productform:{
          name:'',
          list:[],
          checkrow:'',
        }
      };
    },
    mounted(){

    },
    async created() {
      vm = this
    },
    methods: {
      //提交出入库预约单
      // async UpdateOrder(type){
      //   let data = {
      //     'ProductList':[],
      //     'Type': type,//预约类型，1：预约入库，2：预约出库
      //   }
      //   const res = await bussinessApi.UpdateOrder(data)
      //   if(res.ErrCode == 0){
      //     showToast('操作成功')
      //     //返回预约单列表页
      //     vm.$router.push({
      //       path:'/CBookManage'
      //     })
      //   }else{
      //     showToast(res.ErrMsg)
      //   }
      // },
      
      //确定添加产品弹窗
      submitDioFun(){
        //数组重组
        const arr = [{
          Id:'1',
          ProductName:'胶囊',
          Location:'100',
          Rfid:'123456'
        },{
          Id:'2',
          ProductName:'胶囊2',
          Location:'102',
          Rfid:'456789'
        },{
          Id:'1',
          ProductName:'胶囊',
          Location:'102',
          Rfid:'789456'
        },{
          Id:'1',
          ProductName:'胶囊',
          Location:'100',
          Rfid:'789456'
        },]
        var result = arr.reduce((all, next) => {
          //通过判断相同的产品和Location重组数组
          var a = all.filter(res => res.Id == next.Id && res.Location == next.Location)
          return a.length > 0 ?
            (a[0].Rfid.push(`${next.Rfid}`), all) : [...all, { 'Id': next.Id, 'Location':next.Location, 'ProductName':next.ProductName, 'Rfid': [`${next.Rfid}`] }]
        }, []);
        console.log(result)
      },
      //删除产品绑定rfid
      delRfid(index){
        vm.dioform.RFIDlist.splice(index,1)
      },
      //添加产品绑定rfid
      addRfid(){
        if(vm.dioform.rfid == ''){
          showToast('请输入RFID')
          return
        }
        var arr = vm.findPathByLeafId(vm.dioform.location,vm.dioform.wareList)
        
        var _Obj = {
          Id: vm.dioform.Id,
          ProductName: vm.dioform.productName,
          ProductNumber: vm.dioform.productNumber,
          Type: vm.dioform.type,
          Rfid: vm.dioform.rfid,
          Location: vm.dioform.location,
          WareName: arr[0] ? arr[0].Name : '',
          ReserName: arr[1] ? arr[1].Name : '',
          ShelvesName: arr[2] ? arr[2].Name : '',
          LocationName: arr[3] ? arr[3].Name : '',
        }
        vm.dioform.RFIDlist.push(_Obj)
      },
      
      //确认选中当前产品
      submitProduct(){
        this.dioform.Id = this.productform.checkrow.Id
        this.dioform.productName = this.productform.checkrow.ProductName
        this.dioform.productNumber = this.productform.checkrow.ProductNumber
        this.dioform.type = this.productform.checkrow.Type
        this.dioform.spec = this.productform.checkrow.Spec
        this.dioform.supplier = this.productform.checkrow.Supplier
        this.productDio = false
      },
      //打开选择产品弹窗
      openProductDio(){
        this.ProductList()
        this.productDio = true
      },
      //获取产品列表
      async ProductList(){
        let data = {
          'Product':vm.productform.name,
          'Curr':1,
          'Limits':99999,
        }
        const res = await bussinessApi.ProductList(data)
        if(res.ErrCode == 0){
          vm.productform.list = res.Result.list
        }else{
          showToast(res.ErrMsg)
        }
      },
      //单选产品
      clickChange(val){
        this.productform.checkrow = val
      },
      //库区选择
      wareChange(val){
        this.dioform.location = val[val.length-1]
      },
      //递归，通过当前id返回所有父级Id和Name
      findPathByLeafId(Id, nodes, path) {
        if(path === undefined) {
          path = [];
        }
        for(var i = 0; i < nodes.length; i++) {
            var tmpPath = path.concat();
            var _obj = {
              Id:nodes[i].Id,
              Name:nodes[i].Name
            }
            tmpPath.push(_obj)
            // tmpPath.push(nodes[i].Id);
            if(Id == nodes[i].Id) {
              return tmpPath;
            }
            if(nodes[i].Children) {
              var findResult = vm.findPathByLeafId(Id, nodes[i].Children, tmpPath);
              if(findResult) {
                return findResult;
              }
            }
        }
      },
      //获取产品详情
      async ProductDetail(){
        let data = {
          'ProductId': vm.dioform.Id,//产品ID
        }
        const res = await bussinessApi.ProductDetail(data)
        if(res.ErrCode == 0 ){
          vm.dioform.Id = res.Result.ProductId
          vm.dioform.productName = res.Result.ProductName
          vm.dioform.productNumber = res.Result.ProductNumber
          vm.dioform.type = res.Result.Type
          vm.dioform.spec = res.Result.Spec
          vm.dioform.supplier = res.Result.Supplier
        }else{
          showToast(res.ErrMsg)
        }
      },
      //打开弹窗
      openDio(type){
        this.dioType = type
        if(type == 'add'){
          this.dioWidth="800px"
          this.dioTitle="添加产品"
        }
        this.bookDio = true
      },
      //弹窗分页
      // CurrDioChange(val){
      //   this.dioform.curr = val
      //   //执行方法
      // },
      //分页
      CurrentChange(val){
        this.curr = val
        //执行列表方法
      },
      //返回上一页
      backUp(){
        this.$router.push({
          path:'/CBookManage'
        })
      }
    },
    watch: {
      
    }
  }
</script>

<style lang="scss">
.CAddBook{
  .w200{
    width: 200px;
  }
  .w235{
    width: 235px;
  }
  .w300{
    width: 300px;
  }
  .w480{
    width: 480px;
  }
  .btnDiv{
    margin-top: 20px;
    text-align: right;
  }
  .searchBox {
    margin-bottom: 20px;
    .el-form-item{
      margin-bottom: 0;
      .el-form-item__label{
        padding: 0;
      }
    }
    .searchInput {
      width: 300px;
    }
  }
  .contDio{
    .el-form-item{
      margin-bottom: 10px;
      .el-form-item__content{
        line-height: 1.5;
      }
    }
  }
  .addButton {
    margin-bottom: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CStorage/CBookManage/CAddBook.vue